import React, { memo } from "react";

const FabricInfo = memo(({ fabricData, currentSKU }) => {
	const firstFabric = fabricData[0];

	const renderRating = (rating, label) => {
		if (!rating || rating === "NULL") return null;
		return (
			<li>
				{label}: {rating}
			</li>
		);
	};

	return (
		<div className="pt-10">
			<h4 className="text-xl font-bold mt-4 max-xl:mt-0 text-left">
				Fabric Information
			</h4>
			<div className="text-left mx-auto">
				<ul className="list-disc list-inside my-2 mt-3 ml-4 max-lg:px-auto">
					<li>Roll Width: {firstFabric.width}"</li>
					<li>Colours: {fabricData.map((d) => d.thumbnailAlt).join(", ")}</li>
					<li>Composition: {firstFabric.composition || "Please contact us"}</li>
					{renderRating(firstFabric.greenRating, "Eco-Friendly Rating")}
					{renderRating(firstFabric.fireRating, "Fire Resistant Rating")}
					{renderRating(
						firstFabric.antimicrobialRating,
						"Anti Microbial Rating"
					)}
					<li>SKU: {currentSKU}</li>
				</ul>
			</div>
		</div>
	);
});

FabricInfo.displayName = "FabricInfo";

export default FabricInfo;
